import PlaylistCard from './playlist-card'

export default PlaylistCard
